// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".details-wrapper[data-v-a3929c02] {\n  margin: 0;\n}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Orchard/SymptomRecords/EditCreate.vue"],"names":[],"mappings":"AACA;EACE,SAAA;AAAF","sourcesContent":["\n.details-wrapper {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
